import {ReviewsError} from './ReviewsError.js'

export class PostCommentError extends ReviewsError {}
